import React from "react";
import cityLogo from "../Images/logo_12.jpg";
import LanguageTranslate from "./LanguageTranslate";
function HeaderUser() {
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          <div className="translator-holder">
            <div className="logo">
              <img
                src={cityLogo}
                alt="city-logo.png"
                className="img-responsive"
              />
            </div>
            <LanguageTranslate />
          </div>
        </div>
        <div className="fix-white"></div>
      </div>
    </div>
  );
}
export default HeaderUser;
